import React from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

interface GroupHeaderProps {
  icon: React.ReactNode;
  title: string;
  count: number;
  isExpanded: boolean;
  onToggle: () => void;
}

export const GroupHeader: React.FC<GroupHeaderProps> = ({
  icon,
  title,
  count,
  isExpanded,
  onToggle,
}) => {
  return (
    <ListItemButton
      onClick={onToggle}
      sx={{
        px: 2,
        py: 1,
      }}
    >
      <ListItemIcon sx={{ minWidth: 36 }}>{icon}</ListItemIcon>
      <ListItemText
        primary={
          <Typography variant="h5">
            {title} ({count})
          </Typography>
        }
      />
      {isExpanded ? <ExpandLess /> : <ExpandMore />}
    </ListItemButton>
  );
};
